module.exports = __webpack_public_path__ + "static/img/13.141fe04.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/7/13.png
// module id = 291
// module chunks = 0